import PropTypes from 'prop-types';

const PageContainer = ({ title, small, children }) => (
  <div className="page">
    <h1 className="title">{title}</h1>
    {children}
    <style jsx>
      {`
        .page {
          max-width: ${small ? '768px' : '1088px'};
          margin: auto;
          position: relative;
          color: #343434;
          padding: 3.75rem 1rem 4rem 1rem;
        }
        .title {
          color: #212121;
          font-size: 2rem;
          border-bottom: 1px solid #b4b4b4;
          padding-bottom: 0.25rem;
          line-height: 1.2;
          font-weight: 700;
          margin-bottom: 1rem;
        }
        @media screen and (max-width: 680px) {
          .title {
            font-size: 1.5rem;
            text-align: center;
            border-bottom: none;
            padding-bottom: 0;
          }
          .page {
            padding-top: 1.5rem;
          }
        }
        .page :global(p) {
          color: #4e4e4e;
        }
      `}
    </style>
  </div>
);

PageContainer.propTypes = {
  title: PropTypes.string.isRequired,
  small: PropTypes.bool,
  children: PropTypes.node,
};

PageContainer.defaultProps = {
  small: false,
  children: null,
};

export default PageContainer;
